import '../../styles/templates/_page.what-theyre-saying.scss';
import Press from '../modules/Press';
import Ambassadors from '../modules/Ambassadors';
import WhatTheyreSayingSliders from '../modules/WhatTheyreSayingSliders';
const startPageWhatTheyreSaying = () => {
    console.log('UNTUCKit : Template : PageWhatTheyreSaying');
    WhatTheyreSayingSliders.init();
    Press.init();
    Ambassadors.init();
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPageWhatTheyreSaying, { once: true });
}
else {
    startPageWhatTheyreSaying();
}
